import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { TIP_BAR_HEIGHT } from "../shared/constants";

export default class Grid extends AbstractProvidedClass {
    minGrey = 230;
    maxGrey = 180;
    minMinor = 5;
    minorSize = 10;
    dimensions = [];

    display() {
        if (!this.settings.showGrid) {
            return;
        }

        this.p.strokeWeight(1);
        this.dimensions.map((dim) => {
            let px = dim * this.view.scale;
            if (px < 10) {
                return;
            }
            this.p.stroke(dim.color, this.settings.showImage ? 100 : 255);
            this.displayVerticals(dim.currentSize);
            this.displayHorizontals(dim.currentSize);
        });

        this.p.strokeWeight(2);
        this.p.stroke(this.maxGrey);
        // 0 vertical
        this.p.line(this.view.posX, 0, this.view.posX, this.p.height);
        // 0 horizontal
        this.p.line(0, this.view.posY, this.p.width, this.view.posY);
    }

    displayVerticals(currentSize) {
        for (let x = (this.view.posX % currentSize); x < this.p.width; x += currentSize) {
            this.p.line(x, 0, x, this.p.height);
        }
    }

    displayHorizontals(currentSize) {
        for (let y = (this.view.posY % currentSize); y < this.p.height; y += currentSize) {
            this.p.line(0, y, this.p.width, y);
        }
    }

    displayLegend() {
        this.p.strokeWeight(1);
        let rightSpace = 10;
        let bottomSpace = 10 + TIP_BAR_HEIGHT;
        let legendWidth = this.dimensions[1].currentSize + 20;
        let legendHeight = 30;
        let x = this.sideBar.x - legendWidth - rightSpace;
        let y = this.p.height - legendHeight - bottomSpace;

        this.p.stroke(0);
        this.p.fill(this.provider.backgroundColor);
        this.p.rect(x, y, legendWidth, legendHeight);

        this.p.stroke(this.dimensions[1].color);
        for (let i = x + 10; i < x + legendWidth - 10; i += this.dimensions[0].currentSize) {
            this.p.line(i, y + 15, i, y + 25);
        }

        this.p.stroke(0);
        // verticals
        this.p.line(x + 10, y + 15, x + 10, y + 25);
        this.p.line(x + 10 + this.dimensions[1].currentSize, y + 15, x + 10 + this.dimensions[1].currentSize, y + 25);
        // horizontal
        this.p.line(x + 10, y + 20, x + 10 + this.dimensions[1].currentSize, y + 20);

        this.p.noStroke();
        this.p.fill(0);
        this.p.textFont('Helvetica');
        this.p.textSize(10);
        this.p.textAlign(this.p.CENTER);
        this.p.text(this.getLegendScale(), x, y + 3, legendWidth, 10);
    }

    recalculate() {
        this.dimensions = [];
        this.minorSize = null;
        this.getDimensions().forEach((dim) => {
            let currentSize = dim.absSize * this.view.scale;
            if (currentSize < this.minMinor) {
                return;
            }
            if (!this.minorSize) {
                this.minorSize = currentSize;
            }
            this.dimensions.push({
                absSize: dim.absSize,
                currentSize: currentSize,
                label: dim.label,
                color: this.p.map(currentSize, 10, 200, this.minGrey, this.maxGrey, true),
            });
        });
    }

    getLegendScale() {
        return this.dimensions[1].label + ' / ' + this.dimensions[0].label;
    }

    getDimensions() {
        return this.settings.metric ? this.metricDimensions : this.imperialDimensions;
    }

    get metricDimensions() {
        return [
            { absSize: 1, label: '1 cm' },
            { absSize: 10, label: '10 cm' },
            { absSize: 100, label: '1 m' },
            { absSize: 1000, label: '10 m' },
            { absSize: 10000, label: '100 m' },
            { absSize: 100000, label: '1 km' },
        ];
    }

    get imperialDimensions() {
        return [
            { absSize: 2.54, label: '1 in' },
            { absSize: 30.48, label: '1 ft' },
            { absSize: 304.8, label: '10 ft' },
            { absSize: 3048, label: '100 ft' },
            { absSize: 30480, label: '1000 ft' },
            { absSize: 304800, label: '10k ft' },
        ]
    }
}
